import Vue from 'vue';
import Router from 'vue-router';
import i18n from '../plugins/vue-i18n-config';
import { token } from '@/services/TokenService';
import officeReference from './refrences/office';
import departmentReference from '@/router/refrences/department';
import companyReference from '@/router/refrences/company';
import { IS_DEV } from '@/defaults';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../layouts/BaseLayout'),
      redirect: { name: 'main' },
      children: [
        {
          path: 'main',
          name: 'main',
          component: () => import('../layouts/MainLayout'),
          redirect: { name: 'mainHomes' },
          children: [
            {
              path: 'homes',
              name: 'mainHomes',
              component: () => import('../views/Main/Homes'),
              redirect: { name: 'mainHomesList' },
              children: [
                {
                  path: 'index',
                  name: 'mainHomesList',
                  component: () => import('../views/Main/Homes/List'),
                  meta: {
                    title() {
                      return i18n.tc('menu.task', 2) + ' | KPI';
                    }
                  }
                }
              ]
            },

            {
              path: 'tasks',
              name: 'mainTasks',
              component: () => import('../views/' + 'Main/Tasks'),
              redirect: { name: 'mainTasksList' },
              children: [
                {
                  path: 'index',
                  name: 'mainTasksList',
                  component: () => import('../views/Main/Tasks/List'),
                  meta: {
                    title() {
                      return i18n.tc('menu.task', 2) + ' | KPI';
                    }
                  }
                },
                {
                  path: 'create',
                  name: 'mainTasksCreate',
                  component: () => import('../views/Main/Tasks/Create'),
                  meta: {
                    title() {
                      return (
                        i18n.t('crudCreate', {
                          text: i18n.tc('menu.task', 1).toLowerCase()
                        }) + ' | KPI'
                      );
                    }
                  }
                },
                {
                  path: 'update/:id',
                  props: true,
                  name: 'mainTasksUpdate',
                  component: () => import('../views/Main/Tasks/Update'),
                  meta: {
                    title(name) {
                      return (
                        i18n.t('crudEdit', {
                          table: i18n.tc('menu.task', 1).toLowerCase(),
                          name: name
                        }) + ' | KPI'
                      );
                    }
                  }
                },
                {
                  path: 'read/:id',
                  props: true,
                  name: 'mainTasksRead',
                  component: () => import('../views/Main/Tasks/Read'),
                  meta: {
                    title(name) {
                      return (
                        i18n.t('crudRead', {
                          table: i18n.tc('menu.task', 1).toLowerCase(),
                          name: name
                        }) + ' | KPI'
                      );
                    }
                  }
                }
              ]
            },
            {
              path: 'projects',
              name: 'mainProjects',
              component: () => import('../views/Main/Projects'),
              redirect: { name: 'mainProjectsList' },
              children: [
                {
                  path: 'index',
                  name: 'mainProjectsList',
                  component: () => import('../views/Main/Projects/List'),
                  meta: {
                    title() {
                      return i18n.tc('menu.project', 2) + ' | KPI';
                    }
                  }
                },
                {
                  path: 'create',
                  name: 'mainProjectsCreate',
                  component: () => import('../views/Main/Projects/Create'),
                  meta: {
                    title() {
                      return (
                        i18n.t('crudCreate', {
                          text: i18n.tc('menu.project', 1).toLowerCase()
                        }) + ' | KPI'
                      );
                    }
                  }
                },
                {
                  path: 'update/:id',
                  props: true,
                  name: 'mainProjectsUpdate',
                  component: () => import('../views/Main/Projects/Update'),
                  meta: {
                    title(name) {
                      return (
                        i18n.t('crudEdit', {
                          table: i18n.tc('menu.project', 1).toLowerCase(),
                          name: name
                        }) + ' | KPI'
                      );
                    }
                  }
                },
                {
                  path: 'read/:id',
                  props: true,
                  name: 'mainProjectsRead',
                  component: () => import('../views/Main/Projects/Read'),
                  meta: {
                    title(name) {
                      return (
                        i18n.t('crudRead', {
                          table: i18n.tc('menu.project', 1).toLowerCase(),
                          name: name
                        }) + ' | KPI'
                      );
                    }
                  }
                }
              ]
            },
            {
              path: 'teams',
              name: 'mainTeams',
              component: () => import('../views/Main/Teams'),
              redirect: { name: 'mainTeamsList' },
              children: [
                {
                  path: 'index',
                  name: 'mainTeamsList',
                  component: () => import('../views/Main/Teams/List'),
                  meta: {
                    title() {
                      return i18n.tc('menu.team', 2) + ' | KPI';
                    }
                  }
                },
                {
                  path: 'create',
                  name: 'mainTeamsCreate',
                  component: () => import('../views/Main/Teams/Create'),
                  meta: {
                    title() {
                      return (
                        i18n.t('crudCreate', {
                          text: i18n.tc('menu.team', 1).toLowerCase()
                        }) + ' | KPI'
                      );
                    }
                  }
                },
                {
                  path: 'update/:id',
                  props: true,
                  name: 'mainTeamsUpdate',
                  component: () => import('../views/Main/Teams/Update'),
                  meta: {
                    title(name) {
                      return (
                        i18n.t('crudEdit', {
                          table: i18n.tc('menu.team', 1).toLowerCase(),
                          name: name
                        }) + ' | KPI'
                      );
                    }
                  }
                },
                {
                  path: 'read/:id',
                  props: true,
                  name: 'mainTeamsRead',
                  component: () => import('../views/Main/Teams/Read'),
                  meta: {
                    title(name) {
                      return (
                        i18n.t('crudRead', {
                          table: i18n.tc('menu.team', 1).toLowerCase(),
                          name: name
                        }) + ' | KPI'
                      );
                    }
                  }
                }
              ]
            },
            {
              path: 'users',
              name: 'mainUsers',
              component: () => import('../views/Main/Users'),
              redirect: { name: 'mainUsersList' },
              children: [
                {
                  path: 'index',
                  name: 'mainUsersList',
                  component: () => import('../views/Main/Users/List'),
                  meta: {
                    title() {
                      return i18n.tc('menu.user', 2) + ' | KPI';
                    }
                  }
                },
                {
                  path: 'create',
                  name: 'mainUsersCreate',
                  component: () => import('../views/Main/Users/Create'),
                  meta: {
                    title() {
                      return (
                        i18n.t('crudCreate', {
                          text: i18n.tc('menu.user', 1).toLowerCase()
                        }) + ' | KPI'
                      );
                    }
                  }
                },
                {
                  path: 'update/:id',
                  props: true,
                  name: 'mainUsersUpdate',
                  component: () => import('../views/Main/Users/Update'),
                  meta: {
                    title(name) {
                      return (
                        i18n.t('crudEdit', {
                          table: i18n.tc('menu.user', 1).toLowerCase(),
                          name: name
                        }) + ' | KPI'
                      );
                    }
                  }
                },
                {
                  path: 'read/:id',
                  props: true,
                  name: 'mainUsersRead',
                  component: () => import('../views/Main/Users/Read'),
                  meta: {
                    title(name) {
                      return (
                        i18n.t('crudRead', {
                          table: i18n.tc('menu.user', 1).toLowerCase(),
                          name: name
                        }) + ' | KPI'
                      );
                    }
                  }
                },
                {
                  path: 'password-reset/:id',
                  props: true,
                  name: 'mainUsersPasswordReset',
                  component: () => import('../views/Main/Users/PasswordReset'),
                  meta: {
                    title(name) {
                      return (
                        i18n.t('crudPasswordReset', {
                          name: name
                        }) + ' | KPI'
                      );
                    }
                  }
                }
              ]
            },

            {
              path: 'roles',
              name: 'mainRoles',
              component: () => import('../views/Main/Roles'),
              redirect: { name: 'mainRolesList' },
              children: [
                {
                  path: 'index',
                  name: 'mainRolesList',
                  component: () => import('../views/Main/Roles/List'),
                  meta: {
                    title() {
                      return i18n.tc('menu.role', 2) + ' | KPI';
                    }
                  }
                },
                {
                  path: 'create',
                  name: 'mainRolesCreate',
                  component: () => import('../views/Main/Roles/Create'),
                  meta: {
                    title() {
                      return (
                        i18n.t('crudCreate', {
                          text: i18n.tc('menu.role', 1).toLowerCase()
                        }) + ' | KPI'
                      );
                    }
                  }
                },
                {
                  path: 'update/:id',
                  props: true,
                  name: 'mainRolesUpdate',
                  component: () => import('../views/Main/Roles/Update'),
                  meta: {
                    title(name) {
                      return (
                        i18n.t('crudEdit', {
                          table: i18n.tc('menu.role', 1).toLowerCase(),
                          name: name
                        }) + ' | KPI'
                      );
                    }
                  }
                },
                {
                  path: 'read/:id',
                  props: true,
                  name: 'mainRolesRead',
                  component: () => import('../views/Main/Roles/Read'),
                  meta: {
                    title(name) {
                      return (
                        i18n.t('crudRead', {
                          table: i18n.tc('menu.role', 1).toLowerCase(),
                          name: name
                        }) + ' | KPI'
                      );
                    }
                  }
                }
              ]
            },
            {
              path: 'permissions',
              name: 'mainPermissions',
              component: () => import('../views/Main/Permissions'),
              redirect: { name: 'mainPermissionsList' },
              children: [
                {
                  path: 'index',
                  name: 'mainPermissionsList',
                  component: () => import('../views/Main/Permissions/List'),
                  meta: {
                    title() {
                      return i18n.tc('menu.permission', 2) + ' | KPI';
                    }
                  }
                },
                {
                  path: 'create',
                  name: 'mainPermissionsCreate',
                  component: () => import('../views/Main/Permissions/Create'),
                  meta: {
                    title() {
                      return (
                        i18n.t('crudCreate', {
                          text: i18n.tc('menu.permission', 1).toLowerCase()
                        }) + ' | KPI'
                      );
                    }
                  }
                },
                {
                  path: 'update/:id',
                  props: true,
                  name: 'mainPermissionsUpdate',
                  component: () => import('../views/Main/Permissions/Update'),
                  meta: {
                    title(name) {
                      return (
                        i18n.t('crudEdit', {
                          table: i18n.tc('menu.permission', 1).toLowerCase(),
                          name: name
                        }) + ' | KPI'
                      );
                    }
                  }
                },
                {
                  path: 'read/:id',
                  props: true,
                  name: 'mainPermissionsRead',
                  component: () => import('../views/Main/Permissions/Read'),
                  meta: {
                    title(name) {
                      return (
                        i18n.t('crudRead', {
                          table: i18n.tc('menu.permission', 1).toLowerCase(),
                          name: name
                        }) + ' | KPI'
                      );
                    }
                  }
                }
              ]
            },
            {
              path: 'organizations',
              name: 'mainOrganizations',
              component: () => import('../views/Main/Organizations'),
              redirect: { name: 'mainOrganizationsList' },
              children: [
                {
                  path: 'index',
                  name: 'mainOrganizationsList',
                  component: () => import('../views/Main/Organizations/List'),
                  meta: {
                    title() {
                      return i18n.tc('menu.organization', 2) + ' | KPI';
                    }
                  }
                },
                {
                  path: 'create',
                  name: 'mainOrganizationsCreate',
                  component: () => import('../views/Main/Organizations/Create'),
                  meta: {
                    title() {
                      return (
                        i18n.t('crudCreate', {
                          text: i18n.tc('menu.organization', 1).toLowerCase()
                        }) + ' | KPI'
                      );
                    }
                  }
                },
                {
                  path: 'update/:id',
                  props: true,
                  name: 'mainOrganizationsUpdate',
                  component: () => import('../views/Main/Organizations/Update'),
                  meta: {
                    title(name) {
                      return (
                        i18n.t('crudEdit', {
                          table: i18n.tc('menu.organization', 1).toLowerCase(),
                          name: name
                        }) + ' | KPI'
                      );
                    }
                  }
                },
                {
                  path: 'read/:id',
                  props: true,
                  name: 'mainOrganizationsRead',
                  component: () => import('../views/Main/Organizations/Read'),
                  meta: {
                    title(name) {
                      return (
                        i18n.t('crudRead', {
                          table: i18n.tc('menu.organization', 1).toLowerCase(),
                          name: name
                        }) + ' | KPI'
                      );
                    }
                  }
                }
              ]
            },
            ...officeReference,
            ...departmentReference,
            ...companyReference,
            {
              path: 'reports',
              name: 'mainReports',
              component: () => import('../views/Main/Reports'),
              redirect: { name: 'mainReportsProjectOverview' },
              children: [
                {
                  path: 'gantt',
                  name: 'mainReportsGant',
                  component: () => import('../views/Main/Reports/ReportGantt')
                },
                {
                  path: 'project-overview',
                  name: 'mainReportsProjectOverview',
                  component: () => import('../views/Main/Reports/ProjectOverview'),
                  meta: {
                    title() {
                      return i18n.t('menu.projectOverview') + ' | KPI';
                    }
                  }
                },
                {
                  path: 'project-report',
                  name: 'mainReportsProjectReport',
                  component: () => import('../views/Main/Reports/ProjectReport'),
                  meta: {
                    title() {
                      return i18n.t('menu.projectReport') + ' | KPI';
                    }
                  }
                },
                {
                  path: 'time-series',
                  name: 'mainReportsTimeSeries',
                  component: () => import('../views/Main/Reports/TimeSeries'),
                  meta: {
                    title() {
                      return i18n.t('menu.timeSeries') + ' | KPI';
                    }
                  }
                },
                {
                  path: 'time-frame',
                  name: 'mainReportsTimeFrame',
                  component: () => import('../views/Main/Reports/TimeFrame'),
                  meta: {
                    title() {
                      return i18n.t('menu.timeFrame') + ' | KPI';
                    }
                  }
                },
                {
                  path: 'project-details-task',
                  name: 'mainReportsProjectDetailsTask',
                  component: () => import('../views/Main/Reports/ProjectDetailsTask'),
                  meta: {
                    title() {
                      return i18n.t('menu.projectDetailsTask') + ' | KPI';
                    }
                  }
                },
                {
                  path: 'project-details-manager',
                  name: 'mainReportsProjectDetailsManager',
                  component: () => import('../views/Main/Reports/ProjectDetailsManager'),
                  meta: {
                    title() {
                      return i18n.t('menu.projectDetailsManager') + ' | KPI';
                    }
                  }
                },
                {
                  path: 'project-details-employee',
                  name: 'mainReportsProjectDetailsEmployee',
                  component: () => import('../views/Main/Reports/ProjectDetailsEmployee'),
                  meta: {
                    title() {
                      return i18n.t('menu.projectDetailsEmployee') + ' | KPI';
                    }
                  }
                },
                {
                  path: 'users-tasks-report',
                  name: 'mainReportsUserDailyTasks',
                  component: () => import('../views/Main/Reports/UsersTasks'),
                  meta: {
                    title() {
                      return i18n.t('menu.usersTasksReport') + ' | KPI';
                    }
                  }
                },
                {
                  path: 'daily-report',
                  name: 'mainReportsDailyReport',
                  component: () => import('../views/Main/Reports/UserDailyTasks'),
                  meta: {
                    title() {
                      return i18n.t('menu.dailyReport') + ' | KPI';
                    }
                  }
                },
                {
                  path: 'timesheet',
                  name: 'mainReportsMainReportsTimeSheet',
                  component: () => import('../views/Main/Reports/TimeSheet'),
                  meta: {
                    title() {
                      return i18n.t('menu.reportEtmAgent') + ' | KPI';
                    }
                  }
                },
                {
                  path: 'test',
                  name: 'test',
                  component: () => import('../views/Main/Reports/example'),
                  meta: {
                    title() {
                      return i18n.t('menu.activities') + ' | KPI';
                    }
                  }
                },
                {
                  path: 'daily-activity',
                  name: 'mainReportsDailyActivity',
                  component: () => import('../views/Main/Reports/UserDailyActivity'),
                  meta: {
                    title() {
                      return i18n.t('menu.dailyReport') + ' | KPI';
                    }
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'dashboard/:id/:taskId?',
          name: 'dashboard',
          component: () => import('../views/Dashboard'),
          meta: {
            title(name) {
              return (
                i18n.t('projectInDashboard', {
                  name: name
                }) + ' | KPI'
              );
            }
          }
        }
      ]
    },
    {
      path:'/invite',
      name: 'invite',
      component: () => import('../views/Invite'),
    },
    {
      path: '/forbidden',
      name: 'forbidden',
      component: () => import('../views/Forbidden'),
    },

    {
      path: '/auth',
      name: 'auth',
      component: () => import('../layouts/AuthorizationLayout'),
      redirect: { name: 'authLogin' },
      meta: {
        public: true
      },
      children: [
        {
          path: 'login',
          name: 'authLogin',
          component: () => import('../views/Authorization/Login'),
          meta: {
            title() {
              return i18n.t('login') + ' | KPI';
            },
            description() {
              return i18n.t('meta.description.login');
            },
            keywords() {
              return i18n.t('meta.keywords.login');
            }
          }
        },

        // {
        // 	path: 'registration',
        // 	name: 'authRegistration',
        // 	component: () => import('./views/Authorization/Registration/index'),
        // 	meta: {
        // 		title()
        // 		{
        // 			return i18n.t('register') + ' | ETM';
        // 		},
        // 		description()
        // 		{
        // 			return i18n.t('meta.description.registration');
        // 		},
        // 		keywords()
        // 		{
        // 			return i18n.t('meta.keywords.registration');
        // 		},
        // 	},
        // },
        {
          path: 'recovery',
          name: 'authRecovery',
          component: () => import('../views/Authorization/Recovery'),
          meta: {
            title() {
              return i18n.t('passwordRecovery') + ' | KPI';
            },
            description() {
              return i18n.t('meta.description.recovery');
            },
            keywords() {
              return i18n.t('meta.keywords.recovery');
            }
          }
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  let hasToken = !!token.Get();
  let isPublic = to.matched.some((record) => record.meta.public);

  if (to.name === 'authLogin' && !IS_DEV) {
    token.GoToLogin();
    return;
  }

  if (hasToken && isPublic) {
    return next({
      name: 'home'
    });
  }

  if (!hasToken && !isPublic) {
    token.GoToLogin();
  }

  next();

  $('.modal').modal('hide');
});

export default router;
